/**
 * Shared component library for the /bot config tabs (views/bot-live).
 *
 * Every tab composes its UI from these primitives so the 8 tabs share one
 * design language. Import from here rather than redefining chrome locally:
 *
 *   import { SectionCard, StickyActionBar, ToggleRow } from '../shared';
 */

export { default as SectionCard } from './SectionCard';
export { default as StickyActionBar } from './StickyActionBar';
export { default as RadioCard } from './RadioCard';
export { default as ToggleRow } from './ToggleRow';
export { default as FieldRow } from './FieldRow';
export { default as FieldLabel } from './FieldLabel';
export { default as InfoBanner } from './InfoBanner';
export type { InfoBannerVariant } from './InfoBanner';
export { default as TabShell } from './TabShell';
export { default as PreviewTabLayout } from './PreviewTabLayout';
export { default as ChatbotPreviewPanel } from './ChatbotPreviewPanel';
export { default as SubTabBar } from './SubTabBar';
export type { SubTabItem } from './SubTabBar';
export { default as ImageUploadField } from './ImageUploadField';
export { default as DynamicListField } from './DynamicListField';
export type { DynamicListItem } from './DynamicListField';
